module.exports = __webpack_public_path__ + "static/media/HCMM352.adde952a.jpg";